import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";
import Logo from '../../img/Logotipo.webp'
import Modal from "react-modal";


export const customStyles = {
  control: (base, state) => ({
    ...base,
    borderColor: "transparent", // quitamos el borde gris
    boxShadow: state.isFocused
      ? "0 8px 24px rgba(0, 0, 0, 0.15)"
      : "0 4px 12px rgba(0, 0, 0, 0.08)", // sombra clara o fuerte
    minHeight: "44px",
    paddingLeft: "8px",
    fontSize: "1rem",
    borderRadius: 6,
    cursor: "pointer",
    transition: "box-shadow 0.3s ease",
    backgroundColor: "#fff",
  }),
  menu: (base) => ({
    ...base,
    zIndex: 9999,
    boxShadow: "0 16px 40px rgba(0, 0, 0, 0.25)",
    borderRadius: 6,
    marginTop: 6,
    backgroundColor: "#fff",
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isFocused ? "#f3f4f6" : "transparent",
    color: "#374151",
    padding: "10px 15px",
    cursor: "pointer",
    fontWeight: state.isSelected ? "600" : "400",
    transition: "background-color 0.15s ease",
  }),
  singleValue: (base, state) => ({
    ...base,
    color: state.selectProps.menuIsOpen ? "transparent" : "#374151",
    fontWeight: "600",
  }),
  input: (base) => ({
    ...base,
    color: "#374151",
  }),
  placeholder: (base) => ({
    ...base,
    color: "#9ca3af",
    textAlign: "left",
  }),
  dropdownIndicator: (base, state) => ({
    ...base,
    color: state.isFocused ? "#6b7280" : "#9ca3af",
    padding: 4,
    transition: "color 0.2s ease",
    "&:hover": {
      color: "#6b7280",
    },
  }),
  indicatorSeparator: (base) => ({
  ...base,
  backgroundColor: "#e5e7eb", // un gris claro sutil
  marginTop: 8,
  marginBottom: 8,
  width: "1px",
}),

};

export const customStylesSelect = {
  control: (base, state) => ({
    ...base,
    backgroundColor: "rgba(30, 30, 30, 0.8)", // gris oscuro translúcido
    color: "#f5f5f5",
    border: "none",
    outline: "none",
    boxShadow: state.menuIsOpen
      ? "0 6px 14px rgba(255, 215, 0, 0.25)" // glow dorado abajo al abrir
      : "0 2px 6px rgba(255, 215, 0, 0.15)", // más fino cuando cerrado
    minHeight: "44px",
    borderRadius: 8,
    fontSize: "1rem",
    fontWeight: "600",
    paddingLeft: "10px",
    cursor: "pointer",
    transition: "box-shadow 0.3s ease, background-color 0.3s ease",
  }),
  menu: (base) => ({
    ...base,
    backdropFilter: "blur(12px)",
    backgroundColor: "rgba(25, 25, 25, 0.85)", // blur oscuro elegante
    borderRadius: 8,
    marginTop: 6,
    boxShadow: "0 8px 20px rgba(255, 215, 0, 0.25)", // sombra dorada hacia abajo
    zIndex: 9999,
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isFocused
      ? "rgba(255, 215, 0, 0.15)" // dorado suave al pasar el mouse
      : "transparent",
    color: state.isFocused ? "#fff" : "#f0f0f0",
    padding: "10px 15px",
    cursor: "pointer",
    fontWeight: state.isSelected ? "700" : "500",
    transition: "background-color 0.2s ease, color 0.2s ease",
  }),
  singleValue: (base) => ({
    ...base,
    color: "#f5f5f5", // texto visible sobre fondo oscuro
  }),
  placeholder: (base) => ({
    ...base,
    color: "#b0b0b0",
    fontWeight: "500",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: "#cfcfcf",
    padding: 4,
    "&:hover": {
      color: "#fff",
    },
  }),
  indicatorSeparator: (base) => ({
    ...base,
    backgroundColor: "rgba(255, 255, 255, 0.1)",
  }),
  input: (base) => ({
    ...base,
    color: "#f5f5f5",
  }),
};




export const ModalAnimado = ({ isOpen, onClose, children }) => (
  <AnimatePresence>
    {isOpen && (
      <motion.div
        key="overlay"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.6 }}
        className="fixed inset-0 bg-black/20 backdrop-blur-sm flex items-center justify-center z-50"
        onClick={onClose}
      >
        <motion.div
          key="modal"
          initial={{ y: "-100vh", opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: "100vh", opacity: 0 }}
          transition={{ type: "spring", stiffness: 260, damping: 25 }}
          onClick={(e) => e.stopPropagation()}
          className="relative w-[90%] max-w-md h-auto max-h-[90%] bg-gradient-to-br from-white to-neutral-200 mx-auto rounded-2xl shadow-xl overflow-hidden flex flex-col justify-start"
          
        >
           <motion.img
    src={Logo}
    alt="Logo"
    className="absolute inset-0 w-[500px] h-[500px] mx-auto my-auto opacity-10 md:opacity-15 object-contain select-none pointer-events-none"
    initial={{ opacity: 0 }}
    whileInView={{ opacity: 0.15 }}
    transition={{ duration: 1.5 }}
  />
          {/* Contenido scrollable */}
          <div className="flex-1 overflow-y-auto p-4">{children}</div>
        </motion.div>
      </motion.div>
    )}
  </AnimatePresence>
);



 export const PageModal = ({ mostrarModal, onComplete }) => {
  const [loading, setLoading] = useState(true);
  const [showCheck, setShowCheck] = useState(false);

  useEffect(() => {
    if (mostrarModal) {
      setLoading(true);
      setShowCheck(false);

      const loaderTimer = setTimeout(() => {
        setLoading(false);
        setShowCheck(true);
      }, 1000); // Loader más rápido

      const closeTimer = setTimeout(() => {
        setShowCheck(false);
        onComplete();
      }, 2500); // Tiempo suficiente para ver el check

      return () => {
        clearTimeout(loaderTimer);
        clearTimeout(closeTimer);
      };
    }
  }, [mostrarModal, onComplete]);

  return (
    <AnimatePresence>
      {mostrarModal && (loading || showCheck) && (
        <motion.div
          className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            className="bg-white dark:bg-[#1a1a1a] rounded-2xl p-8 shadow-xl flex flex-col items-center min-w-[280px] max-w-sm"
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
          >
            {loading && (
              <motion.div
                key="loader"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                className="flex flex-col items-center space-y-4"
              >
                <div className="w-16 h-16 border-4 border-green-500 border-t-transparent rounded-full animate-spin"></div>
                <p className="text-gray-700 dark:text-gray-200 font-medium text-lg">
                  Cargando...
                </p>
              </motion.div>
            )}

            {showCheck && (
              <motion.div
                key="check"
                initial={{ scale: 0, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                exit={{ scale: 0, opacity: 0 }}
                transition={{ duration: 0.5 }}
                className="flex flex-col items-center space-y-4"
              >
                <div className="w-16 h-16 flex items-center justify-center bg-green-500 rounded-full text-white text-3xl">
                  ✔
                </div>
                <p className="text-gray-700 dark:text-gray-200 font-semibold text-lg">
                  ¡Hecho!
                </p>
              </motion.div>
            )}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export const TermsModal = ({ isOpen, onClose }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <Modal
          isOpen={isOpen}
          onRequestClose={onClose}
          shouldCloseOnOverlayClick={true}
          className="border-none bg-transparent p-0 m-0 relative"
          overlayClassName="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-[9999]"
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.9 }}
            className="bg-white w-[400px] rounded-2xl shadow-lg p-6 text-gray-700"
          >
            <h2 className="text-xl font-semibold text-gray-800 mb-4 text-center">
              Términos y Condiciones
            </h2>

            <p className="text-sm text-gray-600 leading-relaxed mb-4">
              Al utilizar nuestro servicio de pedidos, aceptas los siguientes términos:
              <br /><br />
              • Todos los pedidos deben confirmarse por WhatsApp para su validez.
              <br />
              • Los precios pueden variar según disponibilidad y promociones.
              <br />
              • La información proporcionada por el cliente debe ser veraz y completa.
              <br />
              • 390gramosymassabor no se hace responsable por demoras ocasionadas por terceros (delivery).
              <br />
              • Al completar un pedido, aceptas nuestras políticas de privacidad y uso de datos.
            </p>

            <div className="flex justify-center mt-4">
              <button
                onClick={onClose}
                className="px-4 py-2 text-sm font-semibold text-yellow-500 border border-yellow-500 rounded-lg hover:bg-yellow-500 hover:text-white transition-all"
              >
                Cerrar
              </button>
            </div>
          </motion.div>
        </Modal>
      )}
    </AnimatePresence>
  );
};
